import * as React from 'react'
import { useLocale, useTranslation } from 'hooks'
import {
  withTranslations,
  updateDialingCode,
  togglePhoneCardHidden
} from 'helpers'
import { Address } from '../../types/address'
import Hint from '../Hint'

const AddressListInput: React.FC<AddressListInputProps> = ({
  addresses,
  selectedAddressId = null,
  checkoutPage = false,
  shipping = false,
  addNewAddressPath,
  modelName,
  attributeName = 'address_id',
  dontUpdateDialingCode = false
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  React.useEffect(() => {
    const selectedAddress = addresses.find(
      (address) => address.id === selectedAddressId
    )

    if (selectedAddress && !dontUpdateDialingCode) {
      updateDialingCode(selectedAddress.country)
    }
  }, [])

  const handleClick = (countryCode: Address['country']) => {
    if (!dontUpdateDialingCode) {
      updateDialingCode(countryCode)
    }

    if (checkoutPage) {
      togglePhoneCardHidden(countryCode === 'GB')
    }
  }

  let invalidAddresses = false
  const { pathname } = window.location

  React.useEffect(() => {
    if (addresses.length > 0) {
      const firstAddress = document.getElementById(
        `${modelName}_${attributeName}_${addresses[0].id}`
      )

      firstAddress?.click()
    }
  }, [])

  const radioButtons = addresses.map((address) => {
    const { country, delivery_fee, id, label, is_valid: isValid } = address
    const inputId = `${modelName}_${attributeName}_${id}`
    const checked = id === selectedAddressId

    if (!isValid) {
      invalidAddresses = true
    }

    const deliveryFeeDisplay = delivery_fee || t('shared.free')

    return (
      <div className="field field--radio" key={inputId}>
        <input
          onClick={() => isValid && handleClick(country)}
          disabled={!checked && !isValid}
          type="radio"
          value={id}
          defaultChecked={checked}
          name={`${modelName}[${attributeName}]`}
          id={inputId}
        />
        <label
          htmlFor={inputId}
          className={shipping ? 'no_bg' : ''}
          data-cs-mask
        >
          {`${label}`}
          {/* TODO: temporarily hiding for a test*/}
          {/* {isValid ? (
            checkoutPage && (
              <span className="field--radio__microcopy">
                {t('shared.delivery_fee', {
                  fee: deliveryFeeDisplay
                })}
              </span>
            )
          ) : (
            <span className="field--radio__microcopy">
              <a
                className="btn btn--small btn--secondary control-item__actions--link"
                href={`/account/addresses/${id}?after_path=${encodeURIComponent(
                  pathname
                )}`}
              >
                {t('shared.update')}
              </a>
            </span>
          )} */}
          {!isValid ? (
            <span className="field--radio__microcopy">
              <a
                className="btn btn--small btn--secondary control-item__actions--link"
                href={`/account/addresses/${id}?after_path=${encodeURIComponent(
                  pathname
                )}`}
              >
                {t('shared.update')}
              </a>
            </span>
          ) : null}
        </label>
      </div>
    )
  })

  return (
    <>
      {invalidAddresses && (
        <Hint
          text={t('react_components.address.invalid_addresses')}
          type="error"
          margin={false}
        />
      )}
      <div className={shipping ? 'fieldset--mv-lg' : 'fieldset--mb-lg'}>
        {radioButtons}
      </div>
      <a className="medium underline" href={localiseUrl(addNewAddressPath)}>
        {t('react_components.address.add_address')}
      </a>
    </>
  )
}

interface AddressListInputProps {
  addresses: Address[]
  selectedAddressId?: number
  checkoutPage?: boolean
  shipping?: boolean
  addNewAddressPath: string
  modelName: string
  attributeName?: string
  dontUpdateDialingCode?: boolean
}

export default withTranslations(AddressListInput)
